<template lang='pug'>
  div.d-flex(:class="{'flex-column': isStacked, 'align-center': isStacked}")
    v-tooltip(right open-delay='500')
      template(v-slot:activator="{ on, attrs }")
        v-btn(outlined fab small :color='color'
              :disabled='isLoading || isPendingShare'
              :loading='isSharing'
              @click='$emit("share-character")'
              v-bind='attrs'
              v-on='on')
          v-icon share
      span {{day6Resource.shareLinkHint}}
    div.d-flex.justify-center.align-center(:title="day6Resource.shareLevelHint(shareLevel)"
                                          :class="{'mt-1': isStacked, 'ml-1': !isStacked}")
      v-icon(v-if="isQueryingShareLevel || isPendingShare || isSharing"
              color='grey lighten-1' small) pending
      v-icon(v-else color='grey lighten-1' small) {{shareLevelIcon}}</template>
<script>
import day6Resource from '@/resources/day6'
import { mdiKey } from '@mdi/js'
import { getShareIcon } from '@/components/util/shareIconUtil'

export default {
  name: 'Day6ShareAction',
  props: {
    color: {
      type: String,
      default: 'accent'
    },
    isLoading: Boolean,
    isPendingShare: Boolean,
    isSharing: Boolean,
    shareLevel: String,
    isQueryingShareLevel: Boolean,
    isStacked: Boolean
  },
  data: function () {
    return {
      mdiKey,
      day6Resource
    }
  },
  computed: {
    shareLevelIcon () {
      return getShareIcon(this.shareLevel)
    }
  }
}
</script>
